import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VariationsRoutingModule } from './variations-routing.module';
import { VariationsComponent } from './variations.component';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';


@NgModule({
  declarations: [VariationsComponent],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    VariationsRoutingModule
  ],
  exports: [VariationsComponent]
})
export class VariationsModule { }
